/** Display copy and styling for each `fuelType` the onboarding-prices API returns. */
const FUEL_TYPES = {
  petrol: {
    name: 'Benzine',
    grade: 'Euro 95 / E10',
    description: 'Standard Unleaded 95 (CBS National Avg)',
    icon: 'local_gas_station',
    iconClass: 'bg-secondary-fixed/50 text-secondary',
    tab: 'Benzine',
    previewTitle: 'Benzine (Euro 95)',
  },
  diesel: {
    name: 'Diesel',
    grade: 'B7 Standard',
    description: 'Commercial & Commuter Diesel',
    icon: 'local_shipping',
    iconClass: 'bg-primary-container/20 text-primary-container',
    tab: 'Diesel',
    previewTitle: 'Diesel (B7)',
  },
  ev: {
    name: 'Electric',
    grade: 'DC Fast & AC Public',
    description: '120–150kW HPC public benchmark',
    icon: 'ev_station',
    iconClass: 'bg-tertiary-fixed/70 text-primary',
    tab: 'EV',
    previewTitle: 'Electric Fast DC',
  },
  lpg: {
    name: 'LPG / Autogas',
    grade: 'G3 Eco Blend',
    description: 'Liquefied Petroleum Gas benchmark',
    icon: 'mode_fan',
    iconClass: 'bg-surface-container text-on-surface-variant',
    tab: 'LPG',
    previewTitle: 'LPG / Autogas',
  },
};

const ALIASES = { benzine: 'petrol', gasoline: 'petrol', electric: 'ev' };

export function getFuelMeta(fuelType = '') {
  const key = String(fuelType).toLowerCase();
  const meta = FUEL_TYPES[ALIASES[key] ?? key];
  if (meta) return meta;
  // Unknown type from the backend: still render it with a readable name
  const name = key ? key.charAt(0).toUpperCase() + key.slice(1) : 'Fuel';
  return {
    name,
    grade: null,
    description: 'Onboarding benchmark',
    icon: 'local_gas_station',
    iconClass: 'bg-surface-container text-on-surface-variant',
    tab: name,
    previewTitle: name,
  };
}

/** "Fill Tank Size" for litres, "Charge Size" for kWh. */
export function sizeLabel(unit) {
  return unit === 'kWh' ? 'Charge Size' : 'Fill Tank Size';
}
